import React, { useState, useRef, useEffect } from 'react';

function WeekRowView({ onDoneCountChange }) {
  const today = new Date();
  // Last 5 days (4 previous + today)
  const days = Array.from({ length: 5 }, (_, i) => {
    const d = new Date(today);
    d.setDate(d.getDate() - (4 - i));
    return d;
  });

  const [doneDays, setDoneDays] = useState(new Set([1, 2])); // Start with 2/5 days pre-selected

  // Notify parent of done count changes
  useEffect(() => {
    if (onDoneCountChange) {
      onDoneCountChange(doneDays.size);
    }
  }, [doneDays, onDoneCountChange]);
  const [holdProgress, setHoldProgress] = useState({});
  const holdTimersRef = useRef({});
  const HOLD_DURATION = 500; // ms

  const getDayOfMonth = (date) => date.getDate();
  const isToday = (date) => {
    const t = new Date();
    return date.getDate() === t.getDate() &&
           date.getMonth() === t.getMonth() &&
           date.getFullYear() === t.getFullYear();
  };

  const handleMouseDown = (idx) => {
    const startTime = Date.now();

    const timer = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / HOLD_DURATION, 1);
      setHoldProgress(p => ({ ...p, [idx]: progress }));

      if (progress >= 1) {
        clearInterval(timer);
        delete holdTimersRef.current[idx];
        const newDoneDays = new Set(doneDays);
        if (newDoneDays.has(idx)) {
          newDoneDays.delete(idx);
        } else {
          newDoneDays.add(idx);
        }
        setDoneDays(newDoneDays);
        setHoldProgress(p => ({ ...p, [idx]: 0 }));
      }
    }, 16);

    holdTimersRef.current[idx] = timer;
  };

  const handleMouseUp = (idx) => {
    if (holdTimersRef.current[idx]) {
      clearInterval(holdTimersRef.current[idx]);
      delete holdTimersRef.current[idx];
    }
    setHoldProgress(p => ({ ...p, [idx]: 0 }));
  };

  return (
    <div className="flex gap-1.5">
      {days.map((date, idx) => {
        const dayNum = getDayOfMonth(date);
        const today_flag = isToday(date);
        const isDone = doneDays.has(idx);
        const progress = holdProgress[idx] || 0;

        return (
          <div
            key={idx}
            onMouseDown={() => handleMouseDown(idx)}
            onMouseUp={() => handleMouseUp(idx)}
            onMouseLeave={() => handleMouseUp(idx)}
            onTouchStart={() => handleMouseDown(idx)}
            onTouchEnd={() => handleMouseUp(idx)}
            className={`w-9 h-9 rounded flex items-center justify-center text-xs font-medium cursor-pointer relative overflow-hidden transition-all ${
              isDone
                ? 'bg-green-500 text-slate-900'
                : today_flag
                ? 'bg-bg-dark text-orange-300 border-2 border-orange-400'
                : 'bg-bg-dark text-gray-400'
            }`}
          >
            {/* Progress arc overlay */}
            {progress > 0 && (
              <svg
                className="absolute inset-0 pointer-events-none"
                viewBox="0 0 36 36">
                <circle
                  cx="18"
                  cy="18"
                  r="16"
                  fill="none"
                  stroke={isDone ? '#FF3B30' : '#C4806A'}
                  strokeWidth="2"
                  strokeDasharray={`${2 * Math.PI * 16}`}
                  strokeDashoffset={`${2 * Math.PI * 16 * (1 - progress)}`}
                  strokeLinecap="round"
                  style={{ transition: 'stroke-dashoffset 0.05s linear' }}
                />
              </svg>
            )}
            <span className="relative z-10">{dayNum}</span>
          </div>
        );
      })}
    </div>
  );
}

export default WeekRowView;
